export default "__VITE_ASSET__DAGVVHd4__";